// extracted by mini-css-extract-plugin
module.exports = {"base":"styles_base__1XENv","error":"styles_error__1-aaZ","warning":"styles_warning__2KjSn","success":"styles_success__1ymUH","fixed":"styles_fixed__2YVRG"};